module.exports = __webpack_public_path__ + "img/swap_horizontal_circle_opsz20B.2af480cc.svg";